<form [formGroup]="technicalDataForm" *ngIf="connectionChangeConfig$ | async as config">
  <h2>Technische Informationen</h2>
  <!-- Anschlussänderung -->
  <ng-container *ngIf="config.connectionChangeRequestType === ConnectionChangeRequestTypeEnum.CHANGE">
    <!-- Leistungserhöhung -->
    <ng-container *ngIf="(operations$ | async).powerIncrease">
      <ng-container *ngIf="config.area === AllAreaEnum.Power; else noPower">
        <app-hint-card [type]="'info'" [outlined]="true">
          <p>
            Um eine Leistungserhöhung durchführen zu können, muss der Netzbetreiber die angeschlossene
            Leistung wissen.
          </p>
          <p>
            Sie können die angeschlossene Leistung direkt angeben, oder alternativ die vorliegende
            Hausanschlusssicherung nennen. Bitte füllen Sie mindestens eine der beiden Angaben aus.
          </p>
        </app-hint-card>
        <form-row>
          <mat-form-field
            appearance="outline"
            fxFlex="50"
            *ngIf="technicalDataForm.controls.installedPower as installedPower">
            <mat-label>Angeschlossene Leistung</mat-label>
            <input matInput type="number" [formControl]="installedPower" />
            <span matTextSuffix>{{ powerUnit$ | async }}</span>
            <mat-error *ngIf="installedPower.touched && !!installedPower.errors?.min">
              Die Eingabe darf nicht negativ sein
            </mat-error>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxFlex="50"
            *ngIf="technicalDataForm.controls.installedFuse as installedFuse">
            <mat-label>Hausanschlusssicherung</mat-label>
            <input matInput type="text" [formControl]="installedFuse" />
            <span matTextSuffix>A</span>
          </mat-form-field>
        </form-row>
        <mat-error
          *ngIf="
            (technicalDataForm.controls.installedPower.touched ||
              technicalDataForm.controls.installedFuse.touched) &&
            !!technicalDataForm.errors?.atLeastOneInstallationRequired
          ">
          Angeschlossene Leistung oder Hausanschlusssicherung muss angegeben werden
        </mat-error>
        <br />
      </ng-container>
      <ng-template #noPower>
        <form-row>
          <mat-form-field
            appearance="outline"
            fxFlex="50"
            *ngIf="technicalDataForm.controls.installedPower as installedPower">
            <mat-label>Angeschlossene Leistung</mat-label>
            <input matInput type="number" [formControl]="installedPower" />
            <span matTextSuffix>{{ powerUnit$ | async }}</span>
            <mat-error *ngIf="installedPower.touched && !!installedPower.errors?.min">
              Die Eingabe darf nicht negativ sein
            </mat-error>
          </mat-form-field>
        </form-row>
      </ng-template>
      <app-technical-data-required-power-formpart
        [control]="technicalDataForm.controls.requiredPower"
        [powerUnit]="powerUnit$ | async" />
      <form-row
        *ngIf="
          config.explosiveField !== FieldConfigEnum.HIDDEN &&
          technicalDataForm.controls.civilEngineering as civilEngineering
        ">
        <mat-form-field fxFlex appearance="outline">
          <mat-label>
            Notwendige Tiefbauarbeiten{{ config.explosiveField === FieldConfigEnum.REQUIRED ? '*' : '' }}
          </mat-label>
          <mat-select [formControl]="civilEngineering">
            <mat-option *ngFor="let option of CivilEngineeringOptions" [value]="option">
              {{ CivilEngineeringDisplayNames[option] || '' }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-error *ngIf="civilEngineering.touched && !!civilEngineering.errors?.required">
          Bitte geben Sie an, ob Tiefbauarbeiten notwendig sind
        </mat-error>
      </form-row>
      <ng-container *ngIf="isCivilEngineering$ | async">
        <app-upload-documents
          [inputFormArray]="technicalDataForm.controls.suspectedOrdnanceAreaUploads"
          [documentTag]="'suspectedOrdnanceArea'"
          [showTag]="false"
          [canUpdate]="true"
          [filterCriteria]="'equal'"
          [numberOfUploads]="10"
          [editUpload]="true"
          [showUploadButton]="true"
          [validFormats]="['.pdf']">
          <p>
            Kampfmittelverdachtsfläche*
            <br />
            Bitte laden Sie hier die Einzeichnung/Skizze der Kampfmittelverdachtsfläche für den Tiefbau hoch.
            (Erlaubte Dokumentenformate: ".pdf")
            <br />
          </p>
        </app-upload-documents>
        <hr />
        <mat-error
          *ngIf="
            technicalDataForm.controls.suspectedOrdnanceAreaUploads.touched &&
            technicalDataForm.controls.suspectedOrdnanceAreaUploads.errors?.required
          ">
          Bitte laden Sie mindestens ein Dokument hoch
        </mat-error>
        <br />
      </ng-container>
    </ng-container>
    <!-- Anschlussleitungsverlegung oder Hausanschlusskastenverlegung -->
    <ng-container
      *ngIf="(operations$ | async).moveServiceEntranceBox || (operations$ | async).moveConnectionLine">
      <app-upload-documents
        [inputFormArray]="technicalDataForm.controls.sitePlanUploads"
        [documentTag]="'sitePlan'"
        [showTag]="false"
        [canUpdate]="true"
        [filterCriteria]="'equal'"
        [numberOfUploads]="10"
        [editUpload]="true"
        [showUploadButton]="true"
        [validFormats]="['.pdf']">
        <p>
          Lageplan/Skizze ihres Hausanschlusses
          <br />
          Bitte laden Sie hier den Lageplan oder die Skizze ihres Hausanschlusses hoch. (Erlaubte
          Dokumentenformate: ".pdf")
          <br />
        </p>
      </app-upload-documents>
      <mat-error
        *ngIf="
          technicalDataForm.controls.sitePlanUploads.touched &&
          technicalDataForm.controls.sitePlanUploads.errors?.required
        ">
        Bitte laden Sie mindestens ein Dokument hoch
      </mat-error>
      <br />
    </ng-container>
    <!-- Anschlussleitungsverlegung -->
    <ng-container *ngIf="(operations$ | async).moveConnectionLine">
      <form-row *ngIf="config.lineChangeCommentField !== FieldConfigEnum.HIDDEN">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>
            Grund der Verlegung der Anschlussleitung{{
              config.lineChangeCommentField === FieldConfigEnum.REQUIRED ? '*' : ''
            }}
          </mat-label>
          <textarea
            matInput
            type="text"
            rows="3"
            maxlength="255"
            [formControl]="technicalDataForm.controls.lineChangeComment"></textarea>
          <mat-error
            *ngIf="
              technicalDataForm.controls.lineChangeComment.touched &&
              technicalDataForm.controls.lineChangeComment.errors?.required
            ">
            Bitte geben Sie einen Grund für die Verlegung der Anschlussleitung an
          </mat-error>
        </mat-form-field>
      </form-row>
    </ng-container>
  </ng-container>
  <!-- Temporärer Anschluss -->
  <ng-container *ngIf="config.connectionChangeRequestType === ConnectionChangeRequestTypeEnum.TEMPORARY">
    <app-technical-data-required-power-formpart
      *ngIf="config.requiredPowerFieldInTemporary !== FieldConfigEnum.HIDDEN"
      [control]="technicalDataForm.controls.requiredPower"
      [powerUnit]="powerUnit$ | async"
      [requiredMarker]="false" />
    <h3>Zeitraum des temporären Anschlusses</h3>
    <p>Geben Sie hier an, in welchem Zeitraum sie den Anschluss benötigen</p>
    <form-row>
      <mat-form-field appearance="outline" fxFlex="50">
        <mat-label>Anschlussdauer (Anfangsdatum - Enddatum)</mat-label>
        <mat-date-range-input [rangePicker]="picker1">
          <input matStartDate [formControl]="technicalDataForm.controls.fromDate" />
          <input matEndDate [formControl]="technicalDataForm.controls.toDate" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-date-range-picker #picker1></mat-date-range-picker>
        <mat-error
          *ngIf="
            (technicalDataForm.controls.fromDate.touched &&
              technicalDataForm.controls.fromDate.errors?.required) ||
            (technicalDataForm.controls.toDate.touched && technicalDataForm.controls.toDate.errors?.required)
          ">
          Bitte geben Sie ein Anfangs- und Enddatum ein
        </mat-error>
        <mat-error
          *ngIf="
            (technicalDataForm.controls.fromDate.touched &&
              technicalDataForm.controls.fromDate.errors?.minDate) ||
            (technicalDataForm.controls.toDate.touched && technicalDataForm.controls.toDate.errors?.minDate)
          ">
          Das Datum darf nicht in der Vergangenheit liegen
        </mat-error>
      </mat-form-field>
    </form-row>
  </ng-container>
  <!-- Kein temporärer Anschluss -->
  <ng-container *ngIf="config.connectionChangeRequestType !== ConnectionChangeRequestTypeEnum.TEMPORARY">
    <ng-container *ngIf="config.deviceNumberField !== FieldConfigEnum.HIDDEN">
      <form-row>
        <!-- Transientes Feld -->
        <mat-checkbox [formControl]="technicalDataForm.controls.hasNoMeter">
          Es ist kein Zähler vorhanden
        </mat-checkbox>
      </form-row>
      <form-row *ngIf="!(hasNoMeter$ | async)">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>
            Zählernummer{{ config.deviceNumberField === FieldConfigEnum.REQUIRED ? '*' : '' }}
          </mat-label>
          <input matInput type="text" [formControl]="technicalDataForm.controls.meterNumber" />
          <mat-error
            *ngIf="
              technicalDataForm.controls.meterNumber.touched &&
              !!technicalDataForm.controls.meterNumber.errors?.required
            ">
            Bitte geben Sie Ihre Zählernummer an
          </mat-error>
        </mat-form-field>
      </form-row>
    </ng-container>
  </ng-container>
  <!-- Anschlusstrennung -->
  <ng-container *ngIf="config.connectionChangeRequestType === ConnectionChangeRequestTypeEnum.DISCONNECTION">
    <form-row>
      <mat-checkbox [formControl]="technicalDataForm.controls.isEmptyHouse">
        Das Haus ist unbewohnt und freigeräumt
      </mat-checkbox>
    </form-row>
    <ng-container *ngIf="!!(availableAreas$ | async)?.areas?.length">
      <br />
      <label>Möchten Sie weitere Anschlüsse für die Trennung beantragen?</label>
      <br />
      <mat-selection-list [formControl]="technicalDataForm.controls.areas">
        <mat-list-option [value]="config.area" [disabled]="true" [selected]="true" togglePosition="before">
          {{ AreaDisplayName[config.area] }} (vorausgewählten Sparte)
        </mat-list-option>
        <mat-list-option
          *ngFor="let option of getAvailableAreas(config.area, (availableAreas$ | async)?.areas)"
          [value]="option"
          togglePosition="before">
          {{ AreaDisplayName[option] }}
        </mat-list-option>
      </mat-selection-list>
      <mat-hint>
        Zusätzlich zu der vorausgewählten Sparte können Sie hier weitere Sparten für die Anschlusstrennung
        beantragen. Dadurch müssen Sie nicht für jeden Anschluss einen eigenen Antrag stellen.
      </mat-hint>
      <br />
    </ng-container>
  </ng-container>
  <app-hint-card
    [type]="'info'"
    [outlined]="true"
    [constrainToPage]="true"
    *ngIf="multiAreaWithMeterActive$ | async">
    <h3>Trennung von mehreren Sparten</h3>
    <p>
      Um Rückfragen von Ihrem Netzbetreiber zu vermeiden und einen reibungslosen Ablauf bei der Bearbeitung
      Ihres Antrags zu gewährleisten, benötigen wir von Ihnen die Zählernummern aller ausgewählten Sparten.
      Bitte geben Sie diese im folgenden Anmerkungsfeld an.
    </p>
    <p>
      Bei zwei oder mehr zusätzlichen Sparten, schreiben Sie bitte noch dazu, zu welcher Sparte die jeweilige
      Zählernummer gehört.
    </p>
  </app-hint-card>
  <form-row>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Anmerkung zu den technischen Daten</mat-label>
      <textarea
        matInput
        type="text"
        rows="3"
        maxlength="255"
        [formControl]="technicalDataForm.controls.technicalComment"></textarea>
    </mat-form-field>
  </form-row>
</form>
